/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/shortContent/shortContentRouting.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */

import { generatePath } from 'quartz-routing/react-router';
import { SHORT_CONTENT_URL_FRAGMENT } from '../../constants/Navigation.legacy';
import { OVERVIEW_MODAL_PLAYLIST_PARAM } from 'academy-common-lib/features/overview/overviewConsts';
import { getOverviewModalParams } from 'academy-common-lib/utils/url';
import { PLAYLIST_SEARCH_PARAM } from 'academy-common-lib/features/playlistContent/playlistContentConsts';

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/shortContent/shortContentRouting.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const getShortContentUrl = ({
  shortId,
  playlistId,
  search: locationSearch
}) => {
  const searchParams = new URLSearchParams(locationSearch);
  if (playlistId) searchParams.set(PLAYLIST_SEARCH_PARAM, playlistId.toString());
  const pathname = generatePath(SHORT_CONTENT_URL_FRAGMENT, {
    shortId
  });
  const search = searchParams.toString();
  return {
    search,
    pathname,
    hash: '',
    state: undefined,
    fullUrl: `${pathname}${search ? `?${search}` : ''}`
  };
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/shortContent/shortContentRouting.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const getShortContentOverviewUrl = ({
  shortId,
  playlistId,
  overviewType,
  pathname: locationPathname = '',
  search: locationSearch
}) => {
  const searchParams = new URLSearchParams(locationSearch);
  if (playlistId) searchParams.append(OVERVIEW_MODAL_PLAYLIST_PARAM, playlistId.toString());
  const modalParams = getOverviewModalParams({
    id: shortId,
    type: 'SHORT_FORM_CONTENT',
    source: overviewType
  });
  Object.entries(modalParams).forEach(([key, value]) => {
    searchParams.set(key, value);
  });
  const search = searchParams.toString();
  return {
    search,
    pathname: locationPathname,
    hash: '',
    state: undefined,
    fullUrl: `${locationPathname}${search ? `?${search}` : ''}`
  };
};